import { combineReducers } from 'redux'

import queueReducer from './links'
import filterReducer from './filter'
import sortingReducer from './sorting'
import createLoadingReducer from 'modules/firebase/loadingReducer'
import SiteLink from '../site-link'

export default combineReducers({
  filter: filterReducer,
  list: queueReducer,
  sort: sortingReducer,
  loading: createLoadingReducer(SiteLink),
})



// WEBPACK FOOTER //
// ./src/modules/links/reducers/index.js